import { render, staticRenderFns } from "./TravelRouteList.vue?vue&type=template&id=677e9550&scoped=true"
import script from "./TravelRouteList.vue?vue&type=script&lang=js"
export * from "./TravelRouteList.vue?vue&type=script&lang=js"
import style0 from "./TravelRouteList.vue?vue&type=style&index=0&id=677e9550&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677e9550",
  null
  
)

export default component.exports